import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<rect x=\"0.5\" width=\"20\" height=\"20\" rx=\"10\" fill=\"#1C2026\"></rect><g clip-path=\"url(#clip0_4453_114916)\"><path d=\"M12.6416 10.892L13.8995 12.1494L10.4953 15.5535L7.09161 12.1498L8.34948 10.892L10.4958 13.0494L12.6416 10.892ZM14.7884 8.74567L16.0564 10.0031L14.7995 11.2605L13.5416 10.0031L14.7884 8.74567ZM10.4958 8.74567L11.7532 9.99196L10.4953 11.2498L9.23791 10.0031L10.4953 8.74613L10.4958 8.74567ZM6.20272 8.74567L7.44994 10.0031L6.20365 11.2494L4.94531 10.0031L6.20272 8.74567ZM10.4962 4.45215L13.8999 7.84567L12.6421 9.10261L10.4958 6.95631L8.34994 9.11372L7.09207 7.85631L10.4958 4.45261L10.4962 4.45215Z\" fill=\"#F3BA2F\"></path></g><defs><clipPath id=\"clip0_4453_114916\"><rect width=\"11.1111\" height=\"11.1111\" fill=\"white\" transform=\"translate(4.94531 4.44434)\"></rect></clipPath></defs>", 3)
  ])))
}
export default { render: render }